export default {
  have_account: 'Have an account?',
  sign_in: 'Sign in',
  sign_in_description: 'to use your points & saved info',
  join_free: 'Join free',
  join_description: '— earn rewards on every order',
  join_description_with_discount: `— earn rewards like up to <highlight>{{max_discount}} off</highlight> every order`,
  join_description_with_product_and_discount: `— earn rewards like free {{product_name}} & up to <highlight>{{max_discount}} off</highlight> every order`,
  demo_mode: 'Demo mode',
};
